// ロットの正規化応答(Lots + related.Materials/Users/Groups)を、従来のネスト形(lotRowBase)へ
// 復元する共通ハイドレータ。結合は nestHydrator の宣言的エンジン(生成メタデータのエッジキー)で行う。
// User の結び付けは api 側 Sequelize の関連付け(同名 belongsTo の後勝ち)と同じ規則で
// created_by_user_id を使う(材料検索ハイドレータの Lot→User と同一)。
// Materials の並びはサーバーのバケット順(id 昇順)をそのまま保つ。
import { lotRowBase, NormalizedLotResponse } from "../../schema/console/lot";
import { hasManyOf, requiredUserOf } from "./nestHydrator";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateLots(normalized: NormalizedLotResponse): lotRowBase[] {
  const users = usersWithGroupOf(normalized.related.Users, normalized.related.Groups);
  const materialsOf = hasManyOf("Lot.Materials", normalized.related.Materials);
  const lotUserOf = requiredUserOf("Lot.created_by_user_id", users, "ロット", "登録者");
  return normalized.Lots.map((lot): lotRowBase => ({
    ...lot,
    Materials: materialsOf(lot.id),
    User: lotUserOf(lot),
  }));
}
